<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col>
        <v-card :loading="loading">
          <v-card-text>
            <v-row>
              <v-col class="mt-5 ml-5 mr-5">
                <v-autocomplete
                    class="mt-5"
                    :label="$store.getters.translate('select_exam')"
                    v-model="selected_exam"
                    :items="exams"
                    :return-object="true"
                    item-text="name"
                    item-value="id"
                    @change="generateQuestions"/>
              </v-col>
            </v-row>
            <v-row v-if="questions.length > 0">
              <v-col class="ml-5 mr-5">
                <!--LOOP THROUGH QUESTIONS-->
                <template v-for="(question, question_index) in questions">
                  <p :key="question_index">{{ $store.getters.translate(question.name) }}</p>
                  <v-autocomplete
                      v-if="question.type === 'select_single'"
                      :key="question_index"
                      v-model="answers[question_index]"
                      :items="question.available_answers"/>
                  <v-autocomplete
                      v-else-if="question.type === 'select_multiple'"
                      :key="question_index"
                      v-model="answers[question_index]"
                      :items="question.available_answers"
                      multiple/>
                  <v-text-field
                      v-else-if="question.type === 'text_field'"
                      :key="question_index"
                      v-model="answers[question_index]"/>
                  <v-textarea
                      v-else-if="question.type === 'text_area'"
                      :key="question_index"
                      outlined
                      v-model="answers[question_index]"/>
                  <v-switch
                      v-else-if="question.type === 'boolean'"
                      v-model="answers[question_index]"
                      :key="question_index"
                      dense/>
                  <v-text-field
                      v-else-if="question.type === 'date'"
                      v-model="answers[question_index]"
                      :key="question_index"
                      v-mask="'##-##-####'"
                      placeholder="dd-mm-yyyy"/>
                </template>
              </v-col>
            </v-row>
            <v-row v-if="questions.length > 0">
              <v-col class="mb-5 ml-5 mr-5">
                <v-btn @click="save" :disabled="loading" :loading="loading" large block tile color="primary">
                  {{ $store.getters.translate("save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import helpFunctions from "../../../../plugins/helpFunctions";

export default {
  props: ["exams", "template_id"],
  data() {
    return {
      loading: false,
      template: null,
      all_questions: [],
      questions: [],
      answers: [],
      selected_exam: null,
    }
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$http
          .post(this.$store.getters.appUrl + "v2/portal/get-template", { template_id: this.template_id })
          .then((response) => {
            this.template = response.data;
            this.$http
                .get(this.$store.getters.appUrl + "v2/portal/get-questions")
                .then((response) => {
                  this.loading = false;
                  this.all_questions = response.data;
                })
                .catch((error) => {
                  this.$toasted.error(error);
                  this.loading = false;
                });
          })
          .catch((error) => {
            this.$toasted.error(error);
            this.loading = false;
          });
    },
    save() {
      if(!this.loading) {
        let answers_set = true;
        for (let i = 0; i < this.questions.length; i++) {
          if(this.questions[i].type === 'boolean' && (this.answers[i] === undefined || this.answers[i] === null)) {
            this.answers[i] = false;
          }
          if (this.answers[i] === undefined || this.answers[i] === null) {
            answers_set = false;
            break;
          }
        }
        if (answers_set) {
          this.loading = true;
          this.$http.post(this.$store.getters.appUrl + "v2/portal/exam-form", {
            exam_id: this.selected_exam.id,
            template_id: this.template_id,
            language: this.selected_exam.exam_language,
            questions: this.questions,
            answers: this.answers,
            html: this.generateHtml()
          })
          .then((response) => {
            this.loading = false;
            if (response.status == 200) {
              this.$toasted.success(this.$store.getters.translate("success"));
              this.$emit('form_filled');
            } else {
              var errorMessage = response.data.message;
              var errors = Object.keys(response.data.message);
              this.$toasted.error([errorMessage[errors[0]]]);
            }
          })
          .catch((error) => {
            this.$toasted.error(error.response.data.message);
            this.loading = false;
          });
        }
        else {
          this.$toasted.error(this.$store.getters.translate("please_fill_all_required_fields"));
        }
      }
    },
    generateQuestions() {
      this.questions = [];
      this.all_questions.forEach((question) => {
        let html = this.template.html_nl;
        if(this.selected_exam.exam_language === 'en') {
          html = this.template.html_en;
        }
        if (html.includes("${question-" + question.id + "}")) {
          this.questions.push(question);
        }
      });
    },
    generateHtml() {
      let html = this.template.html_nl;
      if(this.selected_exam.exam_language === 'en') {
        html = this.template.html_en;
      }
      //TABLE BODY, LOOP THROUGH CATEGORIES
      for (let i = 0; i < this.questions.length; i++) {
        //LOOP THROUGH QUESTIONS
        if (html.includes("${question-" + this.questions[i].id + "}")) {
          if (this.answers[i] !== undefined && this.answers[i] !== null) {
            if (this.questions[i].type === "text_field" || this.questions[i].type === "text_area" || this.questions[i].type === "date" || this.questions[i].type === "select_single") {
              html = html.replace("${question-" + this.questions[i].id + "}", this.answers[i]);
            }
            else if (this.questions[i].type === "boolean") {
              if (this.answers[i]) {
                html = html.replace("${question-" + this.questions[i].id + "}", helpFunctions.true_checkbox);
              }
              else {
                html = html.replace("${question-" + this.questions[i].id + "}", helpFunctions.false_checkbox);
              }
            }
            else if (this.questions[i].type === "select_multiple") {
              html = html.replace("${question-" + this.questions[i].id + "}", this.answers[i].join(", "));
            }
          }
        }
      }

      return html;
    },
  },
}
</script>

<style>
.custom-th {
  border:1px solid grey; padding: 10px;
}
.custom-td {
  border:1px solid grey; padding: 2px 10px; height: 24px; vertical-align: middle;
}
</style>